import { IGetLinePartsStrategy } from "./IGetLinePartsStrategy";

/**
 * Represents a line segment with a specified length.
 */
export class Line {
  /**
   * Creates a new instance of the Line class.
   * @param length The length of the line segment.
   */
  constructor(public length: number) {}

  /**
   * Gets the line segments using the specified strategy.
   * @param strategy The strategy for getting the line segments.
   * @returns An array of line segments.
   */
  public getLineParts<T>(strategy: IGetLinePartsStrategy<T>) {
    return strategy.getLineParts(this.length);
  }
}
